import { Subject } from 'rxjs';
import { map } from 'rxjs/operators';

export default function languageChanged(
    locale$: Subject<string>,
    platformCapabilities: Set<string>,
    teardowns: (() => void)[]
) {
    if (!platformCapabilities.has('languageChanged')) {
        return;
    }

    return function(callback: (locale?: string) => void) {
        // pipe/map converts from Behavior Subject to Observable
        // need this to drop the memory event provided by the BehaviorSubject

        const sub = locale$.pipe(map(x => x)).subscribe(callback);
        const unsub = () => sub.unsubscribe();
        teardowns.push(unsub);

        return unsub;
    };
}
